export default "__VITE_ASSET__761dd60f__"